<script>
  import * as restfulService from '../../../services/restfulService'

  import helpers from '@mixins/helper'

  import {required} from 'vuelidate/lib/validators'

  import NavigationButtons from './NavigationButtons'

  import bus from '@utils/bus'

  export default {
    mixins: [helpers],
    components: {NavigationButtons},
    name: 'contrato',
    props: {
      dados: {
        required: true,
        type: Object,
        default: () => ({})
      },
      etapaAtiva: {
        type: Number,
        default: 0
      },
      desabilita: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        textoContrato: ''
      }
    },
    computed: {
      dadosMatricula: {
        get () {
          return this.dados
        },
        set (value) {
          this.$emit('update:dados', value)
        }
      }
    },
    validations: {
      dadosMatricula: {
        matricula: {
          aceito_termos: {required},
          ciente_nao_trocar_cpp: {required}
        }
      }
    },
    watch: {
      etapaAtiva (value) {
        if (value === 3) {
          this.carregaDadosContrato()
        }
      }
    },
    methods: {
      carregaDadosContrato () {
        bus.$emit('show-loader')
        restfulService.get('matricula-online', 'contrato/' + this.dados.matricula.ref_curriculo)
          .then(response => {
            if (response.conteudo) {
              this.textoContrato = response.conteudo
            }
            this.carregandoDados = false
          })
          .catch(e => {
            console.log(e)
          })
        bus.$emit('hide-loader')
      },
      salvarDados () {
        this.desabilita.aba3 = true
        this.desabilita.aba4 = false
        this.$emit('update:etapaAtiva', (this.etapaAtiva + 1))
        this.$emit('update:desabilita', this.desabilita)
      },
      voltar () {
        this.desabilita.aba2 = false
        this.desabilita.aba3 = true
        this.$emit('update:etapaAtiva', (this.etapaAtiva - 1))
        this.$emit('update:desabilita', this.desabilita)
      }
    }
  }
</script>

<template>
    <v-container fluid grid-list-md :pa-0="$vuetify.breakpoint.xsOnly">
        <v-layout row wrap>
          <v-flex xs12 v-if="dadosMatricula.matricula.temPreencherPolo">
            <h4 class="title mb-3">Selecione o polo</h4>
            <v-card flat color="grey lighten-4 mb-3" mx-0>
              <v-card-text class="pa-3">
                <template v-if="dadosMatricula.matricula.polos.length">
                  <v-radio-group v-model="dadosMatricula.matricula.ref_polo" hide-details class="mt-0">
                    <v-radio v-for="(polo, index) in dadosMatricula.matricula.polos"
                             :key="index"
                             color="secondary"
                             :value="polo.id">
                      <div slot="label">{{polo.descricao}}</div>
                    </v-radio>
                  </v-radio-group>
                </template>
                <template v-else>
                  Nenhum polo disponível para seleção.
                </template>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12>
                <h4 class="title mb-3">Leia atentamente o contrato abaixo</h4>
                <v-card height="300"
                        color="grey lighten-4"
                        id="scroll-target"
                        class="scroll-y">
                    <v-card-text v-html="textoContrato"
                                 ref="contratoCardScroll" class="justify-center">
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-layout align-center justify-start >
                    <div class="pl-2">
                        <v-checkbox v-model="dadosMatricula.matricula.aceito_termos"
                                    color="secondary"
                                    label="Confirmo que li e aceito os termos do contrato acima" class="my-0">
                        </v-checkbox>

                        <v-checkbox v-model="dadosMatricula.matricula.ciente_nao_trocar_cpp"
                                    v-if="dadosMatricula.matricula.ref_disciplina_cpp && this.dadosMatricula.matricula.contrato.cpp.turma_virtual === 't'"
                                    color="secondary"
                                    label="Declaro que estou ciente que a cpp (EXP3) é virtual e não possui encontros presenciais, somente online."
                                    class="my-0">
                                    <span>cpp virtual</span>
                        </v-checkbox>
                         <v-checkbox v-else v-model="dadosMatricula.matricula.ciente_nao_trocar_cpp"
                                    color="secondary"
                                    label="Estou ciente que não poderei alterar a CPP depois da confirmação da matrícula"
                                    class="my-0">
                                    <span>cpp virtual</span>
                        </v-checkbox>

                    </div>
                </v-layout>
            </v-flex>
        </v-layout>
        <div class="flex-header">
            <navigation-buttons
              :show-previous="true"
              :show-next="true"
              :previous-click="voltar"
              :next-click="salvarDados"
              :disable-next="((dadosMatricula.matricula.ref_disciplina_cpp?$v.dadosMatricula.$invalid:!dadosMatricula.matricula.aceito_termos) || (dadosMatricula.matricula.temPreencherPolo && !dadosMatricula.matricula.ref_polo))"
            >
            </navigation-buttons>
        </div>
    </v-container>
</template>

<style lang="scss">
    .matricula-contrato {
        width: 100%;
        height: 600px;
    }
</style>



// WEBPACK FOOTER //
// Contrato.vue?8b628c64